import React, { useContext, useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  withRouter
} from 'react-router-dom'
import { routes, otherRoutes, baseURL, loginRoutes } from './routes'
import Header from '../components/Header/Header'
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary'
import LoadingView from '../views/Loading/LoadingView'
import { func } from 'prop-types'
import { AuthContext, LanguageContext, GlobalContext } from '../services/context'
import ContextWrapper from '../components/ContextWrapper/ContextWrapper'
import logoPath from '../assets/images/GrowMore360_Logo.svg'
import DocuSignEmbedView from '../views/Contracts/DocuSignEmbedView'
import { getSupportiveLanguage } from '../services/apiHelper'
import SurveyCodeView from '../views/SurveyCode/SurveyCode'

export const RouterComponent = () => {
  const { auth } = useContext(AuthContext)

  const [languageDataVal, setLanguageDataVal] = useState(['en'])
  const getLanguageData = async () => {
    let langFilter = []
    const res = await getSupportiveLanguage()
    if (res?.data?.result?.length) {
      langFilter = res.data.result.filter(item => item.active === true)
    } 
    setLanguageDataVal(langFilter)
  }

  useEffect(()=>{
    if(auth.loggedIn) {
      getLanguageData()
    }
  },[auth.loggedIn])

  const checkForSuccess = () => {
    const successPathName = '/contracts/return'
    if(window.location.pathname === successPathName){
      return true
    } else {
      return false
    }
  }

  const checkForSurveyCode = () => {
    const surveyCodePathName = '/surveycode'
    if(window.location.pathname === surveyCodePathName){
      return true
    } else {
      return false
    }
  }

  const loggedIn = auth.loggedIn
  let routesArray = []
  const generateRoutes = () => {
    if (loggedIn === 'FAILED') {
      const newRoutes = loginRoutes.map(route => {
        return (<Route
          key={route.title}
          path={route.path}
          component={route.component}
        />
        )})
      routesArray = [...routesArray, ...newRoutes]
    } else {
      otherRoutes.forEach(childRoute => {
        routesArray.push(
          (
            <Route
              exact
              key={childRoute.title}
              path={childRoute.path}
              component={loggedIn === 'SUCCESS' ? childRoute.component : LoadingView}
            />
          )
        )
      })
      routes.forEach(route => {
        if (route.routes){
          route.routes.forEach(childRoute => {
            routesArray.push((
              <Route
                exact
                key={childRoute.title}
                path={childRoute.path}
                component={loggedIn === 'SUCCESS' ? childRoute.component : LoadingView}
              />
            ))
          })
        }
        
        routesArray.push((
          <Route
            key={route.title}
            path={route.path}
            component={loggedIn === 'SUCCESS' ? route.component : LoadingView}
          />
        ))
      })
    }
    return routesArray
  }
  return (
    <Router>
      <LanguageContext.Provider value={languageDataVal}>
        <ContextWrapper>
          <PassThrough />
          {
            checkForSurveyCode() ?
              <Route
                path='/surveycode'
                component={SurveyCodeView}
              />
              : checkForSuccess() ?
                <Route
                  path='/contracts/return'
                  component={DocuSignEmbedView}
                />
                :
                <>
                  <Header routes={routes} logoPath={logoPath} />
                  <ErrorBoundary>
                    <Switch>
                      {generateRoutes()}
                      {loggedIn==='FAILED' &&
          <Redirect from={baseURL} to={'/login'} />
                      }
                      {loggedIn==='SUCCESS' &&
          <Redirect from={baseURL} to={routes[0].path} />
                      }
                    </Switch>
                  </ErrorBoundary>
                </>
          }
        </ContextWrapper>
      </LanguageContext.Provider>
    </Router>
  )
}

export const PassThrough = withRouter(props => {
  const { dispatch } = useContext(GlobalContext)
  useEffect(() => {
    dispatch({
      type: 'TRACK_PAGE_VIEW',
      payload: props.location.pathname
    })
  }, [dispatch, props.location.pathname])
  return null
})

export default RouterComponent

RouterComponent.propTypes = {
  callbackFunc: func
}